"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInfoNotification = exports.parseInfo = void 0;
var conversions_1 = require("../../../utils/conversions");
var SupportedBrowsers_1 = require("../../../settings/SupportedBrowsers");
var parseInfo = function (dataView, device) {
    var _a, _b;
    var bleDevice = device.getBleDevice();
    var serial = (_a = dataView === null || dataView === void 0 ? void 0 : dataView.buffer) === null || _a === void 0 ? void 0 : _a.slice(6, 18);
    var advertisingName = (_b = dataView === null || dataView === void 0 ? void 0 : dataView.buffer) === null || _b === void 0 ? void 0 : _b.slice(18, 34);
    var firmwareVersion = [
        dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(0),
        dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(1),
        dataView === null || dataView === void 0 ? void 0 : dataView.getUint16(2),
    ].join('.');
    var bleDeviceName = bleDevice.name;
    if (navigator.userAgent.indexOf(SupportedBrowsers_1.browsers.CONNECT_BROWSER) !== -1) {
        bleDeviceName = JSON.parse(JSON.stringify(bleDevice)).deviceName;
    }
    return {
        firmwareMajorVersion: dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(0),
        firmwareMinorVersion: dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(1),
        firmwareVersion: firmwareVersion,
        swRevision: dataView === null || dataView === void 0 ? void 0 : dataView.getUint16(2),
        boardIdentifier: dataView === null || dataView === void 0 ? void 0 : dataView.getUint16(4),
        serialNumber: serial !== undefined && (0, conversions_1.buf2hex)(serial),
        advertisingName: advertisingName !== undefined && (0, conversions_1.hex2string)((0, conversions_1.clearHexString)((0, conversions_1.buf2hex)(advertisingName).toString())),
        deviceId: bleDevice.id,
        deviceName: bleDeviceName,
        peripheralId: bleDevice['deviceId'],
        deviceInfoHex: (0, conversions_1.buf2hex)(dataView.buffer),
        bootloaderVersion: device.type === "SmartBox" ? dataView.getUint32(34) : null
    };
};
exports.parseInfo = parseInfo;
var parseInfoNotification = function (e) {
    var currentPayload = (0, conversions_1.buf2hex)(e.buffer);
    var response = {
        payloadHex: currentPayload,
        code: parseInt(currentPayload.substring(0, 4), 16),
        codeHex: "0x".concat(currentPayload.substring(0, 4)),
        payload: parseInt(currentPayload.slice(-4), 16),
    };
    return response;
};
exports.parseInfoNotification = parseInfoNotification;
